export default __webpack_public_path__ + "static/media/2127.634ba6ab.png";